import { EventBus } from '@/models/EventBus';
import type { IEventBus } from '@/interfaces/models';

export class EventBusFactory {
  create(): IEventBus {
    return new EventBus();
  }
}
